// extracted by mini-css-extract-plugin
export default {"container":"MobileSlideContainer_container__9-3na","slider-panel-button":"MobileSlideContainer_slider-panel-button__vStwF","open":"MobileSlideContainer_open__6KjMx"};